export const locale = {
    lang: 'en',
    data: {
        ADDITIONAL_FOOTER: {
            TITLES: {
                POWERED_BY: 'Powered by RealPlus',
            },
        }
    }
};